/**
 * 暖通专业的信号
 */

export const HVAC_SIGNAL = {
    initHvacTunnelControl: "initHvacTunnelControl", // 初始化暖通管道控制器
    initHvacTunnelConnectControl: "initHvacTunnelConnectControl", // 初始化暖通接头控制器
    initHvacDeviceControl: "initHvacDeviceControl", // 初始化排风口控制器
}